var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTicket01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bx-crown",
    d: "M31.6,34.8H4.4c-2.1,0-3.8-1.6-3.9-3.7V3c0-0.8,0.5-1.5,1.3-1.8C2,1.2,2.3,1.2,2.5,1.2c0.6,0,1.1,0.3,1.5,0.7 l6.2,7.5l6.2-7.5C17.3,1,18.6,1,19.4,1.7c0,0,0.1,0.1,0.1,0.1l6.2,7.5L32,1.9c0.4-0.4,0.9-0.7,1.5-0.7c0.2,0,0.4,0,0.6,0.1 c0.8,0.2,1.3,1,1.3,1.8v28.1C35.4,33.2,33.7,34.9,31.6,34.8z M4.4,27.4L4.4,27.4v3.7h27.2v-3.7H4.4z M4.4,8.4v15.2h27.2V8.4 l-4.3,5.2c-0.8,0.8-2.1,0.9-2.9,0.1c0,0-0.1-0.1-0.1-0.1L18,6l-6.2,7.5c-0.8,0.8-2.1,0.9-2.9,0.1c0,0-0.1-0.1-0.1-0.1L4.4,8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTicket01);
export default __webpack_public_path__ + "static/media/ico-ticket-01.4e24bb8c5529a03b0872e86d9e64c695.svg";
export { ForwardRef as ReactComponent };